import React from 'react'
import {
  AvatarBasic,
  DrawerWithIcon,
  Flex,
  Heading,
  Spinner,
} from '@npco/zeller-design-system'

import { currencyFormatter } from 'utils/common'
import { DepositDetails } from 'components/DepositDetails'
import { GenericErrorPage } from 'components/Placeholders/GenericErrorPage/GenericErrorPage'

import { useFetchDeposit } from '../hooks/useFetchDeposit'

interface DepositDrawerProps {
  selectedDepositId: string
  isModalOpen: boolean
  closeModal: () => void
}
export const DepositDrawer = ({
  selectedDepositId,
  isModalOpen,
  closeModal,
}: DepositDrawerProps) => {
  const { deposit, isLoading, error, refetchDeposit } =
    useFetchDeposit(selectedDepositId)

  if (isLoading) {
    return (
      <DrawerWithIcon
        drawerTitle=""
        icon={<></>}
        isOpen={isModalOpen}
        onClose={closeModal}
        overlayClassName="animated-drawer-overlay"
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          height="100%"
          width="100%"
        >
          <Spinner />
        </Flex>
      </DrawerWithIcon>
    )
  }

  if (error || !deposit) {
    return (
      <DrawerWithIcon
        drawerTitle=""
        icon={<></>}
        isOpen={isModalOpen}
        onClose={closeModal}
        overlayClassName="animated-drawer-overlay"
      >
        <GenericErrorPage
          retry={() => refetchDeposit?.()}
          data-testid="fetch-deposit-error"
        />
      </DrawerWithIcon>
    )
  }

  return (
    <DrawerWithIcon
      drawerTitle={deposit.siteName}
      icon={<AvatarBasic text={deposit.siteName} />}
      renderRightHeader={() => (
        <Heading.H2>{currencyFormatter(deposit.totalAmount)}</Heading.H2>
      )}
      isOpen={isModalOpen}
      onClose={closeModal}
      overlayClassName="animated-drawer-overlay"
    >
      <DepositDetails deposit={deposit} />
    </DrawerWithIcon>
  )
}
